'use strict';

module.exports = require('../services/createErrorClass')({
	name: 'UserNotFound',
	message: 'This user does not exist. You could register that name instead.',
	soft: true
});
